module.exports = __webpack_public_path__ + "static/media/coronavirus_black.b06b8055.svg";